import { env } from '@web/core';
import { createAuthService } from './auth/auth_service';
import { createCognitoService } from './auth/cognito_service';
import { createHttpService } from './http/http_service';
import { createConversationStreamClient } from './realtime/conversation_stream_client';
import { createSseClient } from './realtime/sse_client';

const cognitoService = createCognitoService();
export const authService = createAuthService(cognitoService);
/** kanban-api client (default base URL). */
export const httpService = createHttpService(authService);
/** accounts-api client (separate base URL). */
export const accountsHttpService = createHttpService(authService, env.VITE_ACCOUNTS_API_URL);
/** conversation service client (chat messages read/write). */
export const conversationHttpService = createHttpService(
  authService,
  env.VITE_CONVERSATION_API_URL,
);
/** mice-api client (bulk flight purchase projects). */
export const miceHttpService = createHttpService(authService, env.VITE_MICE_API_URL);
/** kanban board-push SSE stream client. */
export const sseClient = createSseClient(authService);
/** conversation chat-push SSE stream client. */
export const conversationStreamClient = createConversationStreamClient(authService);

export { authSync } from './auth/auth_sync';

export type { AuthService } from './auth/auth_service';
export type { HttpService } from './http/http_service';
export type { SseClient } from './realtime/sse_client';
export type { ConversationStreamClient } from './realtime/conversation_stream_client';
